import { GridSortModel } from '@mui/x-data-grid';
import { IListOrderBy } from '../Components/List/list.types';

const GRID_TO_API_SORT_FIELD: Record<string, string> = {
  createdAt: 'created_at',
  dueDate: 'due_date',
};

const API_TO_GRID_SORT_FIELD: Record<string, string> = {
  created_at: 'createdAt',
  createdAt: 'createdAt',
  due_date: 'dueDate',
  dueDate: 'dueDate',
};

export function mapReplacementGridFieldToApi(field: string): string {
  return GRID_TO_API_SORT_FIELD[field] ?? field;
}

export function mapReplacementApiFieldToGrid(field: string): string {
  return API_TO_GRID_SORT_FIELD[field] ?? field;
}

export function buildReplacementSortModel(orderBy?: IListOrderBy): GridSortModel {
  if (!orderBy?.field || !orderBy?.order) {
    return [];
  }

  return [
    {
      field: mapReplacementApiFieldToGrid(orderBy.field),
      sort: orderBy.order.toLowerCase() as 'asc' | 'desc',
    },
  ];
}
